var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-calendar',{staticClass:"er-calendar",attrs:{"data-header-visibilty":_vm.showHeader? 'show':'hide',"range":_vm.inputRange}})}
var staticRenderFns = []

export { render, staticRenderFns }